import { Order, OrderChange, PrintedByUserWithType } from "../types/Order"

export interface GroupedOrder {
  orderId: string
  orderHistory?: OrderChange[]
  orderNumber: string
  amount: number
  userName: string
  deliveryDisplayName: string
  deliveryTimeSlot: string
  orderComment: string
  productComment: string
  storeComment: string
  printedByUsersWithType: PrintedByUserWithType[]
}

export interface GroupedVariant {
  variantId: string
  variantName: string
  totalVariantAmount: number
  orders: GroupedOrder[]
}

export interface ProductionListItem {
  productName: string
  deliveryDate: string
  totalAmount: number
  id: string
  productId: string
  groupedOrders: GroupedVariant[]
}

export const groupProductionList = (orders: Order[]): ProductionListItem[] => {
  const productGroups = new Map<string, ProductionListItem>()

  orders.forEach((order) => {
    order.orderItemsCatering.forEach((item) => {
      const productKey = `${item.productId}_${order.deliveryDate}`
      
      if (!productGroups.has(productKey)) {
        productGroups.set(productKey, {
          productName: item.name,
          deliveryDate: order.deliveryDate,
          totalAmount: 0,
          id: item.productId,
          productId: item.productId,
          groupedOrders: []
        })
      }

      const productGroup = productGroups.get(productKey)!
      productGroup.totalAmount += item.amount

      let variantGroup = productGroup.groupedOrders.find(
        v => v.variantId === item.variantId
      )

      if (!variantGroup) {
        variantGroup = {
          variantId: item.variantId,
          variantName: item.variantName,
          totalVariantAmount: 0,
          orders: []
        }
        productGroup.groupedOrders.push(variantGroup)
      }

      variantGroup.totalVariantAmount += item.amount
      
      variantGroup.orders.push({
        orderId: order.id,
        orderNumber: order.orderNo,
        orderHistory: order.orderHistory,
        amount: item.amount,
        userName: order.userName,
        deliveryDisplayName: order.deliveryDisplayName,
        deliveryTimeSlot: order.deliveryTimeSlot,
        orderComment: order.restaurantMessage || "",
        productComment: item.message || "",
        storeComment: order.storeComment || "",
        printedByUsersWithType: order.printedByUsersWithType || []
      })
    })
  })

  return Array.from(productGroups.values())
}